<template>
  <div>
    <el-alert
      title="这里只查现存量。托盘列按托盘主数据编码显示。"
      type="info" :closable="false" show-icon style="margin-bottom:12px"
    />
    <div class="toolbar">
      <el-input v-model="query.materialCode" clearable placeholder="产品编码" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.materialName" clearable placeholder="产品名称" style="width:160px" @keyup.enter.native="search" />
      <el-select v-model="query.wareHouseId" clearable filterable placeholder="仓库" style="width:160px">
        <el-option v-for="w in warehouses" :key="w.wareHouseId" :label="w.wareHouseName" :value="w.wareHouseId" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
    </div>
    <el-table :data="list" border v-loading="loading">
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="materialCode" label="产品编码" width="130" />
      <el-table-column prop="materialName" label="产品名称" min-width="140" show-overflow-tooltip />
      <el-table-column prop="specs" label="规格" width="120" />
      <el-table-column prop="wareHouseName" label="仓库" min-width="120" />
      <el-table-column prop="wareAreaName" label="库位" width="110" />
      <el-table-column prop="palletCode" label="托盘" width="110" />
      <el-table-column prop="batchNo" label="批次" width="110" />
      <el-table-column prop="quantity" label="库存数量" width="110" align="right" />
      <el-table-column prop="usableQuantity" label="可用数量" width="110" align="right" />
      <el-table-column prop="deductQuantity" label="预留占用" width="110" align="right" />
      <el-table-column prop="supplierName" label="供应商" width="120" show-overflow-tooltip />
      <el-table-column prop="unitName" label="单位" width="70" align="center" />
    </el-table>
    <list-pagination
      :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage" @size-change="onSize"
    />
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import { listInventoryQuantity } from '../../api/quantity'
import { selectEnabledWareHouse } from '../../api/warehouse'

export default {
  components: { ListPagination },
  data() {
    return {
      query: { materialCode: '', materialName: '', wareHouseId: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false, warehouses: []
    }
  },
  created() {
    selectEnabledWareHouse().then(res => { this.warehouses = res.data || [] }).catch(() => {})
    this.load()
  },
  methods: {
    indexMethod(i) { return (this.page - 1) * this.pageSize + i + 1 },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listInventoryQuantity({
        currentPage: this.page,
        pageSize: this.pageSize,
        materialCode: this.query.materialCode,
        materialName: this.query.materialName,
        wareHouseId: this.query.wareHouseId
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    }
  }
}
</script>
